import { useClipboard as useClipboardVueUse } from "@vueuse/core";
import { isOnPrem } from "@/common/environment";

export function useClipboard(options?: Parameters<typeof useClipboardVueUse>[0]) {
  return useClipboardVueUse({
    // enable legacy to allow copying in non-https environments we don't control, e.g. On-Premises
    legacy: isOnPrem,
    ...options,
  });
}
